export class Microsoft365Resource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userCount",
            "baseName": "userCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "groupCount",
            "baseName": "groupCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "sharepointSiteCount",
            "baseName": "sharepointSiteCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "mailboxBytes",
            "baseName": "mailboxBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "onedriveBytes",
            "baseName": "onedriveBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sharepointBytes",
            "baseName": "sharepointBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365Resource.attributeTypeMap;
    }
    constructor() {
    }
}
